module.exports = __webpack_public_path__ + "img/stock0.1bbf97c9.png";